module.exports = __webpack_public_path__ + "static/img/10.9d75eb93.jpg";